module.exports = new __parcel__URL__("castle-gate.514ee9a1.webp").toString();